/* eslint-disable no-use-before-define */
/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-12-15 19:52:57
 */
import '../index.scss'
import React, { useEffect, useState, useRef } from 'react'

import { useNavigate } from 'react-router-dom'
import { Button, Layout, Modal, Spin, Upload, message } from 'antd'
import { PlusOutlined, RightOutlined } from '@ant-design/icons'
import {
  useAppDispatch,
  useAppSelector,
  useContactUrl
} from '../../../app/hooks'
import sensors, { sensorsRole } from '../../../utils/sensors'
import {
  uploadToOSS,
  fetchUploadToken,
  fetchConfig
} from '../../../actions/main'
import { capturePromiseException } from '../../../utils/sentryUtils'
import { readFileAsDataUrl } from '../../../utils/imageUtils'
import parseQueryString from '../../../utils/parseQueryString'
import { v4 as uuid } from 'uuid'
import ContactUS from '../../components/ContactUS'
import BannedAccountModal from '../components/BannedAccountModal'
import {
  createBatchVerifyTask,
  getVerifyLimitCount,
  getVipInfo,
  verifyCountLimitReduce,
  checkVerifyAccountStatus
} from '../../../actions/verify'
import { fetchVerifyAuthConfig } from '../../../slices/verifyAuthSlice'
import desktopLib from '../../../utils/desktopLib'
import creator_icon from '../../../images/verify-auth/creator_icon.png'
import verify_icon from '../../../images/verify-auth/verify_icon.png'
import suppot_icon from '../../../images/verify-auth/suppot_icon.png'
import verify_bg from '../../../images/verify-auth/verify_bg.jpg'
import upload_icon from '../../../images/verify-auth/upload_icon.png'
import CONFIG from '../../../constants/config'
import { setNeedVerifyImages } from '../../../slices/verifyAuthSlice'

import PageHeader from '@/components/PageHeader'
import type { UploadFile, RcFile } from 'antd/es/upload/interface'
const { Content } = Layout
const { Dragger } = Upload
const bucketName = 'net-cloud'

// 验证图片类型
interface VerifyImage extends UploadFile {
  taskUrl?: string
}

export default () => {
  const navigate = useNavigate()
  const contactUsUrl = useContactUrl('验真付费')
  const groupID = useAppSelector((state) => state.group.groupId)
  const isVip = useAppSelector((state) => state.group.isVip)
  const userID = useAppSelector((state) => state.main.user?.user_id)
  const myRole = useAppSelector((state) => state.group.myRole)
  const needVerifyImages = useAppSelector(
    (state) => state.verifyAuth.needVerifyImages
  )
  const [batchVerificationNum, setBatchVerificationNum] = useState(100)
  const [fileList, setFileList] = useState<VerifyImage[]>([])
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewImage, setPreviewImage] = useState('')
  const [verifyBtnDisabled, setVerifyBtnDisabled] = useState(false)
  const [isDragOver, setIsDragOver] = useState(false)
  const uploadBoxRef = useRef<HTMLDivElement>(null)
  const draggerRef = useRef<HTMLDivElement>(null)
  const [isVerifyVip, setIsVerifyVip] = useState(false)
  const dispatch = useAppDispatch()
  const { pageFrom } = parseQueryString()
  const [verifyCount, setVerifyCount] = useState(10)
  const [bannedModalVisible, setBannedModalVisible] = useState(false)
  const [unbanTime, setUnbanTime] = useState('')

  useEffect(() => {
    dispatch(fetchVerifyAuthConfig())
  }, [dispatch])

  useEffect(() => {}, [
    fileList,
    previewVisible,
    previewImage,
    verifyBtnDisabled
  ])

  useEffect(() => {
    handleFetchConfig()
    if (pageFrom === 'back') {
      setFileList(needVerifyImages as VerifyImage[])
    }
    reportSaClickEvent('enterPage')
    handleGetVipInfo()
    handleGetVerifyLimitCount()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleFetchConfig = async () => {
    let res = await dispatch(
      fetchConfig({
        names: CONFIG.KVParams.names
      })
    )
    if (res) {
      const batchLimit =
        res?.items.find((item) => item.name === 'num_of_batch_verfication') ||
        null
      if (batchLimit) {
        setBatchVerificationNum(Number(batchLimit.value))
      }
    }
  }

  const reportSaClickEvent = (actionType) => {
    let params = {}
    if (groupID) {
      params = {
        isGroupVIP: isVip,
        groupID: groupID,
        role: sensorsRole(myRole)
      }
    }
    let from = 'clickTab'
    if (/\/verification/.test(window.location.pathname)) {
      from = pageFrom === 'officialWebsite' ? 'officialWebsite' : 'share'
    }
    sensors.track('web_click_page_photo_verification', {
      actionType: actionType,
      pageFrom: from,
      ...params
    })
  }

  // 封禁弹窗埋点
  const reportBannedModalEvent = (actionType) => {
    let params = {}
    if (groupID) {
      params = {
        isGroupVIP: isVip,
        groupID: groupID,
        role: sensorsRole(myRole)
      }
    }
    let from = 'clickTab'
    if (/\/verification/.test(window.location.pathname)) {
      from = pageFrom === 'officialWebsite' ? 'officialWebsite' : 'share'
    }
    sensors.track('verification_b4138_c7776_exposure', {
      requirement_id: 617,
      track_sign:
        'averification.b4138.c7776.exposure.verification_b4138_c7776_exposure',
      actionType: actionType,
      pageFrom: from,
      ...params
    })
  }

  const handleGetVipInfo = async () => {
    try {
      const res = await dispatch(getVipInfo({ userID }))
      if (res.status === 0) {
        const verifyVipInfo = res.vips.find((ele) => ele.kind === 13) // ele.kind === 13 验真Vip的kind值为13
        verifyVipInfo && setIsVerifyVip(verifyVipInfo.isVip || false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  // 检查账号封禁状态
  const checkAccountBannedStatus = async () => {
    try {
      const accountStatusRes = await dispatch(checkVerifyAccountStatus({}))
      // accountStatusRes 已经是 result.data，直接访问 show1 和 time1
      if (accountStatusRes) {
        const { show1, time1 } = accountStatusRes
        // show1 === 1 表示账号被封禁
        if (show1 === 1) {
          // 格式化解封时间
          let unbanTimeStr = ''
          if (time1) {
            const unbanDate = new Date(parseInt(time1) * 1000)
            const year = unbanDate.getFullYear()
            const month = String(unbanDate.getMonth() + 1).padStart(2, '0')
            const day = String(unbanDate.getDate()).padStart(2, '0')
            const hours = String(unbanDate.getHours()).padStart(2, '0')
            const minutes = String(unbanDate.getMinutes()).padStart(2, '0')
            unbanTimeStr = `${year}年${month}月${day}日${hours}:${minutes}分`
          }
          setUnbanTime(unbanTimeStr)
          setBannedModalVisible(true)
          // 埋点：弹窗显示
          reportBannedModalEvent('show')
          return true // 返回 true 表示被封禁
        }
      }
      return false // 返回 false 表示未封禁
    } catch (error) {
      console.error('检查账号封禁状态失败:', error)
      // 如果检查失败，返回 false，允许继续操作
      return false
    }
  }

  const handleGetVerifyLimitCount = async (): Promise<void> => {
    try {
      const res = await dispatch(getVerifyLimitCount({}))
      if (res.status === 0) {
        let count = 10
        if (res.rights && res.rights?.length) {
          res.rights.forEach((ele) => {
            // 2是验真
            if (ele.type === 2) {
              count = ele.count
            }
          })
        }
        setVerifyCount(count)
      }
    } catch (error) {
      console.log(error)
    }
  }
  const handleVerifyCountLimitReduce = async (count: number) => {
    try {
      const res = await dispatch(
        verifyCountLimitReduce({
          type: 2, // 2照片验真
          count: count // 数值为正
        })
      )
      if (res.status === 0) {
        console.log('次数消耗', res)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleVerifyRecordClick = () => {
    reportSaClickEvent('clickVerificationRecord')
    Modal.confirm({
      title: '验真记录 正在开发中',
      content: '如有需要可点击下方催促开发',
      okText: '催促开发',
      onOk: () => {
        message.info('已收到反馈')
        reportSaClickEvent('clickPopVerificatonRecordUrge')
      },
      onCancel: () => reportSaClickEvent('clickPopVerificatonRecordCancel')
    })
  }

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await readFileAsDataUrl(file.originFileObj)
    }
    setPreviewVisible(true)
    setPreviewImage(file.url || file.preview)
  }

  const handleCancel = () => setPreviewVisible(false)

  const handleChange = (newList) => {
    if (newList.length > fileList.length) {
      reportSaClickEvent('clickAddUploadOnePic')
    } else if (newList.length < fileList.length) {
      reportSaClickEvent('clickDeleteOneUploadedPic')
    }
    setFileList(newList)
  }

  const handleDragOver = (event) => {
    event.preventDefault()
    setIsDragOver(true)
  }
  const handleDragLeave = () => {
    setIsDragOver(false)
  }

  const handleDrop = async (event) => {
    event.preventDefault()
    setIsDragOver(false)
    if (verifyBtnDisabled) {
      message.info('文件上传中，请耐心等待！')
      return
    }

    // 在异步操作之前先保存 dataTransfer.files，避免事件对象被释放
    const files = event.dataTransfer?.files
    if (!files || files.length === 0) {
      return
    }

    // 先检查账号封禁状态
    const isBanned = await checkAccountBannedStatus()
    if (isBanned) {
      console.log('账号被封禁，阻止上传')
      return // 阻止上传
    }

    let currentFileList = Array.from(files)
    if (currentFileList.length + fileList.length > batchVerificationNum) {
      reportSaClickEvent('showTip')
      message.info(
        `批量验真一次性最多${batchVerificationNum}张，已为您上传前${batchVerificationNum}张选中的照片`
      )
      currentFileList = currentFileList.splice(
        0,
        batchVerificationNum - fileList.length
      )
    }
    const validFiles = (currentFileList as File[]).filter((file: File) =>
      /\.(jpg|jpeg|png)$/i.test(file.name)
    )
    if (validFiles.length !== currentFileList.length) {
      message.warning('只支持上传 .jpg, .jpeg, .png 格式的文件！')
      return
    }
    reportSaClickEvent('DragUploadLocalPhotos')
    handleBeforeUpload(currentFileList[0] as File, currentFileList as File[])
  }

  // 处理上传按钮点击，先进行封禁校验
  const handleUploadButtonClick = async (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    // 先检查账号封禁状态
    const isBanned = await checkAccountBannedStatus()
    if (isBanned) {
      return // 阻止打开文件选择器
    }

    // 如果未封禁，通过 ref 访问 Dragger 内部的 input 并触发点击
    if (draggerRef.current) {
      // 在包装 div 内部查找 Upload 组件的 input 元素
      const input = draggerRef.current.querySelector(
        'input[type="file"]'
      ) as HTMLInputElement | null
      if (input) {
        input.click()
      }
    }
  }

  const uploadProps = {
    name: 'file',
    multiple: true,
    beforeUpload: (file: RcFile, fileList: RcFile[]) => {
      reportSaClickEvent('clickUploadLocalPhotos')
      handleBeforeUpload(file, fileList)
    },
    accept: '.jpg, .jpeg, .png',
    showUploadList: false
  }

  let taskStart = false
  let taskList: VerifyImage[] = []
  let count = 0

  const handleBeforeUpload = async (
    file: RcFile | File,
    currentFileList: (RcFile | File)[]
  ) => {
    // 如果用户通过其他方式（如直接点击 Dragger 区域）选择文件，也需要校验
    // 这里保留校验作为兜底，但主要校验在按钮点击时进行
    const isBanned = await checkAccountBannedStatus()
    if (isBanned) {
      return false // 阻止上传
    }

    if (currentFileList.length + fileList.length > batchVerificationNum) {
      reportSaClickEvent('showTip')
      message.info(
        `批量验真一次性最多${batchVerificationNum}张，已为您上传前${batchVerificationNum}张选中的照片`
      )
      currentFileList = currentFileList.splice(
        0,
        batchVerificationNum - fileList.length
      )
    }
    if (!currentFileList.length) return false
    setVerifyBtnDisabled(true)
    if (!taskStart) {
      let ossToken = JSON.parse(localStorage.getItem('ossData') || 'null')
      if (
        !ossToken ||
        !ossToken[bucketName] ||
        ossToken[bucketName].expire < Date.now() / 1000
      ) {
        ossToken = await dispatch(fetchUploadToken())
      }
      taskStart = true
      taskList = new Array(currentFileList.length).fill(
        undefined
      ) as VerifyImage[]
      taskList.forEach((_, index) =>
        handleUpload(
          currentFileList[index],
          index,
          currentFileList.length,
          ossToken
        )
      )
    }
  }
  const handleUpload = async (
    file: RcFile | File,
    index: number,
    length: number,
    ossToken: any
  ) => {
    const filename = uuid() + '.' + file.name.split('.').pop()
    uploadToOSS({
      key: `authVerify/photos/${filename}`,
      OSSAccessKeyId: ossToken[bucketName]['accessid'],
      policy: ossToken[bucketName]['policy'],
      Signature: ossToken[bucketName]['signature'],
      file: file
    })
      .then(() => {
        count++
        taskList[index] = {
          uid: filename,
          name: filename,
          status: 'done',
          url: `https://net-cloud.xhey.top/authVerify/photos/${filename}?x-oss-process=image/resize,w_400`,
          taskUrl: `https://net-cloud.xhey.top/authVerify/photos/${filename}`
        }
        if (count === length) {
          setFileList([...fileList, ...taskList])
          setVerifyBtnDisabled(false)
          taskList = []
          taskStart = false
        }
      })
      .catch(() => {
        const reader = new FileReader()
        reader.onload = (e) => {
          count++
          taskList[index] = {
            uid: (file as RcFile).uid || filename,
            name: file.name,
            status: 'error',
            url: e.target?.result as string
          }
          if (count === length) {
            setFileList([...fileList, ...taskList])
            setVerifyBtnDisabled(false)
            taskList = []
            taskStart = false
          }
        }
        reader.readAsDataURL(file as Blob)
        capturePromiseException(new Error('Upload failed'))
      })
  }

  const handleCreateVerifyTask = async () => {
    reportSaClickEvent('clickBatchVerification')
    if (verifyCount <= 0 || fileList.length > verifyCount) {
      Modal.confirm({
        title: '验真次数不足',
        // content: `每日可验${
        //   isVerifyVip ? 1000 : 10
        // }次, 如有需要, 可联系客服增加次数`,
        okText: '联系客服',
        // cancelText: '残忍离开',
        onOk: () => {
          if (desktopLib.isDesktop) {
            desktopLib.openContact(contactUsUrl)
          } else {
            window.open(
              contactUsUrl,
              '_blank',
              'width=500,height=600,right=0,bottom=0'
            )
          }
        },
        onCancel: () => {}
      })
      return
    }

    setVerifyBtnDisabled(true)
    reportSaClickEvent('clickStartVerification')
    dispatch(setNeedVerifyImages(fileList as any))
    let photoInfoList = fileList
      .map((ele) => {
        if (ele.taskUrl) {
          return {
            photoUrl: ele.taskUrl,
            pictureClassification: 'web'
          }
        }
        return null
      })
      .filter((item) => item !== null)
    try {
      // 记录验真次数消耗
      handleVerifyCountLimitReduce(photoInfoList.length)
      const res = await dispatch(
        createBatchVerifyTask({
          photoInfoList: photoInfoList
        })
      )
      setVerifyBtnDisabled(false)
      if (res.status === 0) {
        navigate(`/verifyAuth/process/${res.taskID}/${photoInfoList.length}`)
      } else if (res.status === -126) {
        reportSaClickEvent('showPopVerificationRetry')
        Modal.info({
          title: '当前验真人数较多',
          content: '请等待十分钟后再试',
          okText: '我知道了',
          onOk: () => reportSaClickEvent('clickPopVerificationRetryKnow')
        })
      }
    } catch (error) {
      setVerifyBtnDisabled(false)
      console.log(error)
    }
  }

  return (
    <Layout className="verify-auth">
      {isDragOver && (
        <div
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          className="upload-mask"
        >
          <div className="dashed-box">
            <div className="text">松开上传</div>
          </div>
        </div>
      )}
      <PageHeader
        className="Header"
        ghost={true}
        title={
          <div className="verify-auth-header">
            <h4>照片验真</h4>
          </div>
        }
        extra={
          <>
            <Button
              onClick={() => {
                handleVerifyRecordClick()
              }}
            >
              验真记录
            </Button>
          </>
        }
      />
      <Content
        className="content"
        style={{
          backgroundImage: `url(${verify_bg})`,
          backgroundSize: 'cover'
        }}
      >
        <div className="main-content-container" onDragOver={handleDragOver}>
          <div className="main-content">
            <div className="introduce">
              <div className="title">
                全行业首创<span className="verify-text">验真平台</span>
              </div>
              <div className="desc-item">
                <img src={creator_icon} alt="" className="item-icoon" />
                验真服务开创者
              </div>
              <div className="desc-item">
                <img src={verify_icon} alt="" className="item-icoon" />
                首创“时间防篡改+照片验真技术”双重校验
              </div>
              <div className="desc-item">
                <img src={suppot_icon} alt="" className="item-icoon" />
                支持批量验真，单次最多{batchVerificationNum}张
              </div>
            </div>
            <Spin spinning={verifyBtnDisabled}>
              <div className="upload" ref={draggerRef}>
                <Dragger
                  className={`${
                    !fileList.length ? 'upload-drag' : 'upload-drag-hide'
                  }`}
                  {...uploadProps}
                >
                  <p className="ant-upload-drag-icon">
                    <img src={upload_icon} alt="" />
                  </p>
                  <p className="ant-upload-text">将照片或文件拖拽至此</p>
                  <p className="ant-upload-hint">
                    仅支持今日水印相机拍摄的照片
                  </p>
                  <p className="ant-upload-hint">
                    支持格式：JPG、PNG，单张大小不超过 10MB
                  </p>
                  <Button
                    className="upload-btn"
                    onClick={handleUploadButtonClick}
                  >
                    上传照片
                  </Button>
                </Dragger>
                {!!fileList.length && (
                  <div
                    ref={uploadBoxRef}
                    className={`${
                      fileList.length ? 'upload-box' : 'upload-box-hide'
                    }`}
                  >
                    <div style={{ flex: 1 }}></div>
                    <Upload
                      listType="picture-card"
                      fileList={fileList}
                      multiple={true}
                      accept={'.jpg, .jpeg, .png'}
                      onPreview={handlePreview}
                      onChange={({ fileList: newFileList }) =>
                        handleChange(newFileList as VerifyImage[])
                      }
                      onRemove={(file) => {
                        setFileList(
                          fileList.filter((ele) => ele.uid !== file.uid)
                        )
                      }}
                      beforeUpload={handleBeforeUpload}
                    >
                      {fileList.length >= batchVerificationNum ? null : (
                        <div style={{ fontSize: 30, color: '#888' }}>
                          <PlusOutlined />
                        </div>
                      )}
                    </Upload>
                    <Modal
                      open={previewVisible}
                      footer={null}
                      onCancel={handleCancel}
                    >
                      <img
                        alt="example"
                        style={{ width: '100%' }}
                        src={previewImage}
                      />
                    </Modal>
                  </div>
                )}
                {!!fileList.length && (
                  <div className="start-verify">
                    <div className="vip-remind">
                      {isVerifyVip && <span>已是验真会员，畅享批量验真</span>}
                    </div>
                    <span className="btn-container">
                      <Button
                        className={`start-verify-btn ${
                          verifyBtnDisabled && 'start-verify-btn-disabled'
                        }`}
                        disabled={verifyBtnDisabled}
                        onClick={handleCreateVerifyTask}
                      >
                        {isVerifyVip ? '开始验真' : '批量验真(限免)'}
                      </Button>
                    </span>
                  </div>
                )}
              </div>
            </Spin>
          </div>
        </div>
        <div className="contact-us">
          <ContactUS fromPage="Web验真API">
            <>
              <span className="contact-us-text">照片验真API</span>
              <Button
                type="link"
                className="contact-us-btn"
                onClick={() => {
                  reportSaClickEvent('cickContactUs')
                }}
              >
                马上了解
                <RightOutlined />
              </Button>
            </>
          </ContactUS>
        </div>
        {/* 账号封禁弹窗 */}
        <BannedAccountModal
          open={bannedModalVisible}
          unbanTime={unbanTime}
          onClose={() => setBannedModalVisible(false)}
          onContactService={() => {
            // 埋点：点击联系客服
            reportBannedModalEvent('contactUs')
          }}
          onConfirm={() => {
            // 埋点：点击我知道了
            reportBannedModalEvent('ok')
          }}
        />
      </Content>
    </Layout>
  )
}
